<template>
  <div>
    <div style="display: flex; align-items: flex-start">
      <el-card style="width: 100%">
        <div
          slot="header"
          class="clearfix"
        >
          <span>Csomagolások</span>
          <el-button
            style="float: right; margin-top: -5px; margin-right: 5px;"
            type="success"
            size="small"
            @click="$router.replace('/processes/packings/add-out-packing')"
            icon="el-icon-plus"
            v-can="'packing.create'"
          >
            Új csomagolás
          </el-button>
        </div>
        <div v-loading="tableFilterLoading" style="min-height: 81px;">
          <table-filter
            v-if="config"
            :config="config"
            action="packing/fetchAll"
          />
        </div>
        <list />
        <template v-if="$route.meta.showPackingViewDialog">
          <PackingViewDialog
            :packingId="$route.params.id"
          />
        </template>
        <template v-if="$route.meta.showAddPackingDialog">
          <packing-dialog
            type="inPacking"
          />
        </template>
        <template v-if="$route.meta.showAddOutPackingDialog">
          <packing-dialog
            type="outPacking"
          />
        </template>
      </el-card>
    </div>
  </div>
</template>
<script>
  import List from '../../components/processes/packings/List';
  import PackingDialog from '../../components/processes/packings/Dialog';
  import PackingViewDialog from '../../components/processes/packings/View';
  import TableFilter from '../../components/TableFilter';

  export default {
    components: {
      List,
      PackingDialog,
      TableFilter,
      PackingViewDialog,
    },
    data() {
      return {
        config: null,
        tableFilterLoading: false,
      };
    },
    methods: {
      async setConfig() {
        this.tableFilterLoading = true;
        let users = this.$store.getters['user/users'];
        let products = await this.$store.dispatch('product/search');
        let storages = this.$store.getters['storage/storages'];
        if(!storages.length) {
          await this.$store.dispatch('storage/fetchAll');
          storages = this.$store.getters['storage/storages'];        }
        if (!users.length) {
          await this.$store.dispatch('user/fetchAll');
          users = this.$store.getters['user/users'];
        }
        this.config = [
          {
            type: 'select',
            name: 'product_id',
            options: products,
            label: 'Termék',
            labelCallback: product => product && `${product.name}` || '',
            valueKey: 'id',
            defaultSearch: true,
          },
          {
            type: 'select',
            name: 'storage_id',
            options: storages,
            label: 'Raktár',
            labelCallback: storage => storage && `${storage.name}` || '',
            valueKey: 'id',
          },
          {
            type: 'text',
            name: 'count',
            label: 'Mennyiség',
          },
          {
            type: 'select',
            name: 'type',
            options: [
              { label: 'Becsomagolas', value: 'inPacking'},
              { label: 'Kicsomagolas', value: 'outPacking'},
            ],
            labelCallback: type => type && `${type.label}` || '',
            label: 'Csomagolás',
            valueKey: 'value',
          },
          {
            type: 'select',
            options: users,
            name: 'creator_user_id',
            label: 'Rögzítette',
            labelCallback: user => user && `${user.last_name} ${user.first_name} (@${user.username})` || '',
            valueKey: 'id',
          },
        ];
        this.tableFilterLoading = false;
      }
    },
    async mounted() {
      await this.setConfig();
    }
  };
</script>

